module.exports = __webpack_public_path__ + "static/media/tinyLogout.35948cf2.svg";